import { PickingPanelBlock } from '@ekkogmbh/apisdk';
import { MenuItem } from '@mui/material';
import React from 'react';
import { StyledSelectField } from 'src/Common/Components/Forms/StyledSelectField';

interface Props {
  label: string;
  value: PickingPanelBlock;
  onChange: (newValue: PickingPanelBlock) => void;
}

const selectables = Object.values(PickingPanelBlock).map((v, i) => (
  <MenuItem key={i} value={v}>
    {v}
  </MenuItem>
));

export default function PickingPanelBlockSelect({ label, value, onChange }: Props): React.JSX.Element {
  return (
    <StyledSelectField
      label={label}
      value={value}
      onChange={(e) => {
        onChange(e.target.value as PickingPanelBlock);
      }}
    >
      {selectables}
    </StyledSelectField>
  );
}
